import React, { Component } from 'react';
import styled from '@emotion/styled';
import { connect } from 'react-redux';
import Restore from '../components/pages/Restore';
import { validateResetPasswordToken, setNewPassword } from '../actions/authActions';
import queryString from 'query-string';
import Footer from '../components/blocks/Footer';
import PageWithFooter from '../components/blocks/PageWithFooter';
import NotificationBanner from '../components/blocks/NotificationBanner';
import { clearNotificationMessage } from '../actions/notificationActions';
import breakpoints from '../theme/material/breakpoints';
import { AppDispatch, RootState } from '../store';

const StyledFooter = styled(Footer)({
  [breakpoints.down('sm')]: {
    position: 'relative',
  },
});

class RestoreContainer extends Component {
  constructor(props) {
    super(props);

    const queryStringParsed = queryString.parse(props.location.search);

    // validate resettoken
    props.validateReset(queryStringParsed.token);
  }

  render() {
    // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
    const { notification, isAuthenticated, location, clearNotificationMessage, loadPageUrl } = this.props;

    const queryStringParsed = queryString.parse(location.search);

    return (
      <React.Fragment>
        <NotificationBanner
          notification={notification}
          clearNotificationMessage={clearNotificationMessage}
          loadPageUrl={loadPageUrl}
          isAuthenticated={isAuthenticated}
          location={location}
        />

        <div id="main">
          <PageWithFooter customMobileStyles={{ paddingBottom: 20 }}>
            {/* @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389 */}
            <Restore token={queryStringParsed.token} {...this.props} />
          </PageWithFooter>
          <StyledFooter />
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: RootState) => {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    tokenValid: state.auth.resetTokenValidity,
    errors: state.common.errors,
    notification: state.notification,
  };
};

const mapDispatchToProps = (dispatch: AppDispatch, ownProps: RootState) => {
  return {
    clearNotificationMessage() {
      dispatch(clearNotificationMessage());
    },
    loadPageUrl(linkUrl: string) {
      dispatch(clearNotificationMessage());
      ownProps.navigate(linkUrl);
    },
    handleSubmit: formData => {
      dispatch(setNewPassword(formData));
    },
    validateReset: (token: string) => {
      dispatch(validateResetPasswordToken(token));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RestoreContainer);
